import { Dayjs } from "dayjs"
import { IUserRenewal } from "./userRenewal.types"

export class UserRenewal implements IUserRenewal {
  constructor(
    public id: number,
    public createdAt: Dayjs,
    public meterpointIds: number[],
    public uploadedAt?: Dayjs,
  ) {}
}
